import './Nav.css';
import { Link } from 'react-router-dom'
import React, { useState, useEffect, useRef, useContext } from 'react';
import { SharedVariableContext } from '../../App'; // Importez le contexte depuis App.js

import frFlag from './Assets/fr.png';
import ukFlag from './Assets/uk.png';
import esFlag from './Assets/es.png';
import deFlag from './Assets/de.png';

import translations from './Texte';

export default function NavBar()
{

    const { selectedOption, setSelectedOption } = useContext(SharedVariableContext);

    // Sélectionner la langue, avec français comme langue par défaut
    const lang = translations[selectedOption.value] || translations.fr;

    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef(null);

    const options = [
                        { value: 'fr', label: 'Français', img: frFlag },
                        { value: 'uk', label: 'Anglais', img: ukFlag },
                        { value: 'es', label: 'Espagnol', img: esFlag },
                        { value: 'de', label: 'Allemand', img: deFlag },
                    ];

    useEffect(() => {
                        const handleClickOutside = (event) => {if (selectRef.current && !selectRef.current.contains(event.target)) {setIsOpen(false);}};
                        document.addEventListener('click', handleClickOutside);
                        return () => document.removeEventListener('click', handleClickOutside);
                    }, []);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleOptionClick = (option) => {
                                                setSelectedOption(option);
                                                setIsOpen(false);
                                            };



    return(
        <nav>
            <Link to="/"><div className='MenuElement'>{lang.accueil}</div></Link>
            <Link to="/SommaireTest"><div className='MenuElement'>{lang.sommaire}</div></Link>
            <Link to="/Majlist"><div className='MenuElement'>{lang.nouveaute}</div></Link>
            <div ref={selectRef} className="custom-select">
                <div className="selected-option" onClick={toggleDropdown}>
                    <img src={selectedOption.img} alt={selectedOption.label} />
                    <span className='langue'>{selectedOption.label}</span>
                </div>
                <div className={`dropdown ${isOpen ? 'open' : ''}`}>
                    {options.map((option) => (
                        <div key={option.value} className="option" onClick={() => handleOptionClick(option)}>
                            <img src={option.img} alt={option.label} />
                            <span className='langue'>{option.label}</span>
                        </div>
                    ))}
                </div>
            </div>
        </nav>

    )
}